// @flow
import React from 'react';

import { NATIVE_INFERENCE_POOL_ID, NATIVE_INFERENCE_POOL_NAME } from '../../../constants';
import { DeleteRenderer } from '../grid-utils/renderers';

import { NativeInferencePoolDeleteWarningModal } from './NativeInferencePoolDeleteWarningModal';

export const NativeInferencePoolDeleteRenderer = ({ data }) => {
  const nativeInferencePoolId = data[NATIVE_INFERENCE_POOL_ID];
  const poolName = data[NATIVE_INFERENCE_POOL_NAME];

  return (
    <DeleteRenderer>
      {(isDeleteModalOpen, setDeleteModalOpen) => (
        <NativeInferencePoolDeleteWarningModal
          isOpen={isDeleteModalOpen}
          nativeInferencePoolId={nativeInferencePoolId}
          poolName={poolName}
          setOpen={setDeleteModalOpen}
        />
      )}
    </DeleteRenderer>
  );
};
